<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>角色名称：</label>
                <el-input v-model="search_Obj.f_rolename" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" v-loading="loading" border stripe>
                <el-table-column prop="rolename" label="角色名称" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <RoleMenu
            width="1200px"
            :id="model_id"
            title="配置权限"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </RoleMenu>
    </div>
</template>

<script>
import Btns from "@/components/common/btns";
import LabBtns from "@/components/common/labbtns";
import Edit from "./edit";
import RoleMenu from "./rolemenu";
import listutil from "@/libs/listutil";

export default {
    name: "roleList",
    mixins: [listutil],
    components: {Edit, RoleMenu, Btns, LabBtns},
    data() {
        return {
            m_name: '角色',
            menu_id: 1200,
            list_url: "/api/admin/role/list",
            search_Obj: {
                f_rolename: '',
            },
            del_Obj:{
                url:'/api/admin/role/del',
                data:{
                    ids:''
                }
            },
        };
    },
    mounted() {},
    methods: {
        jurisdiction(index, row){
            this.model_id = row.id
            this.infoshow = true
        }
    }
};
</script>